import * as tslib_1 from "tslib";
import { takeUntil } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import * as meta from '../../actions/meta';
import * as orders from '../../actions/orders';
import * as cart from '../../../cart/actions/cart';
import * as fromOrders from '../../reducers';
import * as fromCart from '../../../cart/reducers';
import * as fromAuth from '../../../auth/reducers';
import { ContainerBase } from '../../../core/base/container-base';
import chaining from '../../../core/helpers/chaining';
import * as fromBase from '../../../base/reducers';
var OrderPageContainer = /** @class */ (function (_super) {
    tslib_1.__extends(OrderPageContainer, _super);
    function OrderPageContainer(store) {
        var _this = _super.call(this) || this;
        _this.store = store;
        _this.fullWidthView$ = store
            .pipe(select(fromBase.isFullWidthViewEnabled));
        _this.orders$ = store.pipe(select(fromOrders.getOrders), takeUntil(_this.destroyed$));
        _this.loadingLines$ = store.pipe(select(fromOrders.isLinesLoading), takeUntil(_this.destroyed$));
        _this.cartProducts$ = store.pipe(select(fromCart.getCartProducts), takeUntil(_this.destroyed$));
        _this.currency$ = store.pipe(select(fromAuth.getCurrency), takeUntil(_this.destroyed$));
        _this.orderLines$ = store
            .pipe(select(fromCart.getCurrentOrderLines), takeUntil(_this.destroyed$));
        _this.isExpanding$ = store.pipe(select(fromOrders.isExpanding), takeUntil(_this.destroyed$));
        // Dispatch init
        _this.store.dispatch(new meta.Init());
        _this.orderLines$
            .subscribe(function (orderLines) { return _this.orderLines = orderLines; });
        return _this;
    }
    OrderPageContainer.prototype.expand = function () {
        this.store.dispatch(new orders.Expand());
    };
    OrderPageContainer.prototype.addCart = function (event) {
        var orderLineId = chaining(this.orderLines.find(function (line) { return chaining(line, 'product._id') === chaining(event, 'product'); }), '_id');
        if (chaining(event, 'quantity') > 0) {
            this.store.dispatch(new cart.Add({
                product: event.product,
                quantity: event.quantity
            }));
        }
        else if (event.quantity <= 0 && orderLineId)
            this.store.dispatch(new cart.Remove({
                lineId: orderLineId
            }));
    };
    return OrderPageContainer;
}(ContainerBase));
export { OrderPageContainer };
